import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import localeEn from '@angular/common/locales/en';
import localeEsMX from '@angular/common/locales/es-MX';
import localeExtraEsMX from '@angular/common/locales/extra/es-MX';
import { registerLocaleData } from '@angular/common';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { NZ_DATE_LOCALE, NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import {
  HttpOxioSourceInterceptor,
  HttpTokenInterceptor,
  HttpOxioNamespaceInterceptor,
} from './core/interceptors';
import { HttpLoaderFactory } from './core';
import { PublicPagesModule } from './public-pages/public-pages.module';
import { CoreModule } from './core/core.module';
import { HttpErrorInterceptor } from './core/interceptors/http.error.interceptor';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import {
  ApmModule,
  ApmService,
  ApmErrorHandler,
} from '@elastic/apm-rum-angular';
const maskConfig: Partial<IConfig> = {
  validation: false,
};
registerLocaleData(localeEsMX, localeExtraEsMX);
// AoT requires an exported function for factories

@NgModule({
  declarations: [AppComponent],
  imports: [
    ApmModule,
    BrowserModule,
    AppRoutingModule,
    IconsProviderModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    PublicPagesModule,
    CoreModule,
    NgxIntlTelInputModule,
    ScrollToModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxMaskModule.forRoot(maskConfig),
  ],
  providers: [
    ApmService,
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpOxioNamespaceInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpOxioSourceInterceptor,
      multi: true,
    },
    { provide: NZ_I18N, useValue: en_US },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(service: ApmService) {
    if (APP_ENV && typeof APP_ENV.APM_URL !== 'undefined') {
      // Agent API is exposed through this apm instance
      service.init({
        serviceName: 'portal',
        serverUrl: APP_ENV.APM_URL,
        serviceVersion: APP_ENV.RELEASE_VERSION || 'UnknownVersion',
      });
    }
  }
}
